import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Capacitor, Plugins } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import { PushNotifications } from '@capacitor/push-notifications';
import { SplashScreen } from '@capacitor/splash-screen';
import { Storage } from '@capacitor/storage';
import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update';
import { Platform, PopoverController } from '@ionic/angular';
import { CapacitorChime } from 'capacitor-chime';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { firstValueFrom } from 'rxjs';
import { Environment } from 'src/environments/environment';
import { SELECTED_THEME } from 'src/version';
import { AppUpdateComponent } from './components/app-update/app-update.component';
import { BrandService } from './services/brand.service';
import { StateService } from './services/state.service';
import { DEVICE_TOKEN_IDENTIFIER } from './types/Device';

const { LocalNotifications2 } = Plugins;
const APP_UPDATE_KEY = 'APP_UPDATE_ACTION';
export enum UPDATE_STRATEGY {
  IMMEDIATE = 'immediate',
  OPTIONAL = 'optional',
}
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  currentBrand = 'theme-smartcr';
  constructor(
    private platform: Platform,
    private stateService: StateService,
    private brandService: BrandService,
    private http: HttpClient,
    private popoverCtrl: PopoverController,
  ) {
    if (Capacitor.isNativePlatform() && this.platform.is('ios')) {
      SplashScreen.show({
        showDuration: 1000,
        autoHide: true,
      });
    }
    console.log('selected_theme', SELECTED_THEME);
    if (SELECTED_THEME) {
      this.currentBrand = `theme-${SELECTED_THEME}`
      this.brandService.set(this.currentBrand);
    } else {
      this.brandService.set('theme-smartcr');
    }
  }

  async ngOnInit() {
    await LocalNotifications.requestPermissions();
    try {
      // @ts-ignore
      LocalNotifications2?.registerActionTypes({
        types: [
          {
            id: 'OPEN_PRODUCT',
            actions: [
              {
                id: 'view',
                title: 'Product'
              }, {
                id: 'remove', title: 'Remove', destructive: true
              },
              {
                id: 'response',
                title: 'Response',
                input: true
              }
            ]
          }
        ]
      }).catch((err: any) => console.warn(err));
      if (Capacitor.isNativePlatform()) {
        const appUpdateInfo = await AppUpdate.getAppUpdateInfo();
        if (appUpdateInfo.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE) {
          const appUpdateActionMap = JSON.parse((await Storage.get({ key: APP_UPDATE_KEY }))?.value || '{}');
          if (!appUpdateActionMap[appUpdateInfo.availableVersion]) {
            const companionURL = Environment.COMPANION_URL;
            // For Debugging
            // const companionURL = window.location.origin;
            const updateInformation = await firstValueFrom(this.http.get<any>(`${companionURL}/assets/app-update-info.json`)).catch(() => {
              return {};
            })
            const updateStrategy: UPDATE_STRATEGY = (updateInformation || {})[appUpdateInfo.availableVersion]?.updateStrategy || 'optional';
            const popover = await this.popoverCtrl.create({
              component: AppUpdateComponent,
              componentProps: {
                updateStrategy,
              },
              backdropDismiss: false,
              translucent: true,
              cssClass: 'app-update-popover',
              mode: 'ios',
            });
            await popover.present();
            await popover.onDidDismiss().then((res) => {
              if (!res?.data) {
                appUpdateActionMap[appUpdateInfo.availableVersion] = 'dismissed';
                return Storage.set({ key: APP_UPDATE_KEY, value: JSON.stringify(appUpdateActionMap) });
              }
              return;
            });
          }
        }
      }
    } catch (e) {
      console.error(e);
    }

    this.addTelehealthListeners();
  }

  addTelehealthListeners() {
    try {
      // Register voIP token for iOS
      if (this.platform.is('ios')) {
        CapacitorChime.addListener(
          'registration',
          (token) => {
            console.log('setting token value', token.value);
            SecureStoragePlugin.set({ key: DEVICE_TOKEN_IDENTIFIER, value: token.value });
          }
        );
      } else {
        if (Capacitor.isNativePlatform()) {
          PushNotifications.addListener(
            'registration',
            (token: any) => {
              console.log('setting token value', token.value);
              SecureStoragePlugin.set({ key: DEVICE_TOKEN_IDENTIFIER, value: token.value });
            }
          );

          PushNotifications.requestPermissions().then(async (permissionStatus) => {
            // Register with Apple / Google to receive push via APNS/FCM
            console.log('weird', permissionStatus);
            PushNotifications.register();
            if (permissionStatus.receive === 'prompt') {
              permissionStatus = await PushNotifications.requestPermissions();
            }

            if (permissionStatus.receive !== 'granted') {
              console.log('Push notification permission not granted');
            }
          });
        }
      }

      CapacitorChime.addListener(
        'initiateCall',
        (action: any) => {
          this.stateService.setTelehealthCallStatus(true);
        }
      );

    } catch (e) {
      console.log(e);
    }
  }
}
